import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const HrBrandScaleMediumKindDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 5.30652L14.2402 8.50196L14.3882 8.71303L14.6346 8.78853L18.3659 9.93162L16.0191 13.0496L15.8641 13.2555L15.8685 13.5133L15.9344 17.4152L12.2438 16.1468L12 16.063L11.7563 16.1468L8.06568 17.4152L8.13157 13.5133L8.13593 13.2555L7.98091 13.0496L5.63413 9.93162L9.36542 8.78853L9.61188 8.71303L9.75985 8.50196L12 5.30652Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.5}
            />
            <circle
                cx={10.2}
                cy={9.87605}
                r={1.27925}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={13.7724}
                cy={9.87681}
                r={1.28}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={14.7699}
                cy={13.0167}
                r={1.28}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={9.32358}
                cy={13.0167}
                r={1.28}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle cx={12} cy={15.0501} r={1.28} fill="var(--bloko-icon-color, var(--bloko-icon-color-default))" />
        </svg>
    ),
    'Hr'
);
export default HrBrandScaleMediumKindDefault;
